'use strict';
import { db } from './firebase'

import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
    updateDoc,
    doc,
    deleteDoc,
} from "firebase/firestore";
import { ProjectsTypes } from '../interfaces/ProjectsTypes';
import { SuiteTypes } from '../interfaces/SuiteTypes';

const getProjects = async (user_uuid: string) => {

    const q = query(
        collection(db, `projects`),
        where("user_uuid", 'array-contains', user_uuid)
    );

    const projects: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            projects.push(doc.data());
        });
    }

    const projectsDetails = [];

    for (let index = 0; index < projects.length; index++) {
        const suites = await getSuitesByProject(user_uuid, projects[index].project_id)

        var totalTestCases = 0

        for (let i = 0; i < suites.length; i++) {
            const testCases = suites[i].test_cases.length
            totalTestCases += testCases
        }

        projectsDetails.push({ testCasesSize: totalTestCases, suitesSize: suites.length, ...projects[index] })
    }

    return projectsDetails
};

const createProject = async (project: ProjectsTypes) => {

    if (checkForSpecialChar(project.title)) {
        throw new Error('O Título não pode conter caracteres especiais.')
    }

    var projectExists = null

    projectExists = await checkProjectExists(project.user_uuid[0], project.project_id)

    if (projectExists.length > 0) {
        throw new Error('Já existe um projeto com esse ID.')
    } else {
        await addDoc(collection(db, "projects"), project);
    }
};

var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";

var checkForSpecialChar = function (string: string) {
    for (let i = 0; i < specialChars.length; i++) {
        if (string.indexOf(specialChars[i]) > -1) {
            return true
        }
    }
    return false;
}

const updateProject = async (project_id: string, data: any) => {

    const q = query(
        collection(db, `projects`),
        where("project_id", "==", project_id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "projects", querySnapshot.docs[0].id);

    await updateDoc(document, data)
};

const checkProjectExists = async (user_uuid: string, project_id: string) => {

    const q = query(
        collection(db, `projects`),
        where("user_uuid", "array-contains", user_uuid),
        where("project_id", "==", project_id)
    );

    const querySnapshot = await getDocs(q);
    const data: any = [];

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

const getProjectById = async (user_uuid: string, project_id: string) => {

    const q = query(
        collection(db, `projects`),
        where("user_uuid", "array-contains", user_uuid),
        where("project_id", "==", project_id)
    );

    const querySnapshot = await getDocs(q);

    var project: ProjectsTypes = {} as ProjectsTypes;
    const projectsDetails = [];

    if (querySnapshot.size === 1) {
        project = querySnapshot.docs[0].data() as ProjectsTypes
    }

    const suites = await getSuitesByProject(user_uuid, project.project_id)

    var totalTestCases = 0

    for (let i = 0; i < suites.length; i++) {
        const testCases = suites[i].test_cases.length
        totalTestCases += testCases
    }

    projectsDetails.push({ testCasesSize: totalTestCases, suitesSize: suites.length, ...project })

    return projectsDetails[0]
};

const getSuitesByProject = async (user_uuid: string, project_id: string) => {

    const q = query(
        collection(db, `suites`),
        // where("user_uuid", "==", user_uuid),
        where("project_id", "==", project_id)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

const createSuite = async (suite: SuiteTypes) => {
    await addDoc(collection(db, "suites"), suite);
};

const updateSuite = async (id: number, title: string) => {

    const q = query(
        collection(db, `suites`),
        where("id", "==", id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "suites", querySnapshot.docs[0].id);

    await updateDoc(document, { title })
};

const createUpdateTestCase = async (user_uuid: string, project_id: string, suite_id: number, data: any, id: string) => {

    console.log('-----------')
    console.log('project_id', project_id)
    console.log('suite_id', suite_id)
    console.log('data', data)

    const q = query(
        collection(db, `suites`),
        where("project_id", "==", project_id),
        // where("user_uuid", "==", user_uuid),
        where("id", "==", suite_id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "suites", querySnapshot.docs[0].id);

    const data2 = querySnapshot.docs[0].data().test_cases.filter((item: { id: string; }) => item.id !== id);

    await updateDoc(document, { test_cases: [...data2, ...data] })
};

const createExecution = async (data: any) => {
    await addDoc(collection(db, "executions"), data);
};

const deleteTestCase = async (project_id: string, suite_id: string, id: string) => {

    const q = query(
        collection(db, `suites`),
        where("project_id", "==", project_id),
        where("id", "==", suite_id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "suites", querySnapshot.docs[0].id);
    const data = querySnapshot.docs[0].data().test_cases.filter((item: { id: string; }) => item.id !== id);

    await updateDoc(document, { test_cases: [...data] })
};

const deleteSuite = async (suite: SuiteTypes) => {

    const q = query(
        collection(db, `suites`),
        where("id", "==", suite.id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "suites", querySnapshot.docs[0].id);

    await deleteDoc(document)
};

const deleteProject = async (project_id: string) => {

    const q = query(
        collection(db, `projects`),
        where("project_id", "==", project_id),
    );

    const querySnapshot = await getDocs(q);
    const document = doc(db, "projects", querySnapshot.docs[0].id);

    await deleteDoc(document)

    deleteAllSuitesFromProject(project_id)
};

const deleteAllSuitesFromProject = async (project_id: string) => {

    const q = query(
        collection(db, `suites`),
        where("project_id", "==", project_id),
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach(async (doc) => {
        await deleteDoc(doc.ref);
    });

};

const getExecutions = async (project_id: string) => {

    const q = query(
        collection(db, `executions`),
        where("project_id", "==", project_id)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    data.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    });

    return data
};

const deleteExecution = async (id: string) => {

    console.log(id)

    const q = query(
        collection(db, `executions`),
        where("id", "==", id),
    );

    const querySnapshot = await getDocs(q);

    console.log(querySnapshot.size)

    querySnapshot.forEach(async (doc) => {
        await deleteDoc(doc.ref);
    });
};

export {
    getProjects,
    createProject,
    getProjectById,
    createSuite,
    getSuitesByProject,
    createUpdateTestCase,
    deleteTestCase,
    deleteSuite,
    updateSuite,
    createExecution,
    getExecutions,
    updateProject,
    deleteProject,
    deleteExecution,
};
